import { render } from "./ListOrderProducts.vue?vue&type=template&id=b0de8096"
import script from "./ListOrderProducts.vue?vue&type=script&lang=js"
export * from "./ListOrderProducts.vue?vue&type=script&lang=js"

import "./ListOrderProducts.vue?vue&type=style&index=0&id=b0de8096&lang=scss"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__